import { useEffect } from "react";
import type { LoginInfo } from "../api/types";
import { pageTitle } from "./page-head";
import { ThemeSwitch } from "./theme-switch";

/** Die Gründe, mit denen `/api/auth/callback` zurückschickt (`?login_error=`). */
export const LOGIN_ERRORS: Record<string, string> = {
  missing_role: "Deinem Konto ist die Rolle „Platform.Admin“ nicht zugewiesen.",
  wrong_tenant: "Nur Konten aus der Solutec-Directory.",
  access_denied: "Anmeldung abgebrochen oder nicht zugewiesen.",
  state: "Die Anmeldung ist abgelaufen — bitte noch einmal.",
};

export function loginErrorText(code: string): string {
  return LOGIN_ERRORS[code] ?? `Anmeldung fehlgeschlagen (${code})`;
}

export function Login({ info }: { info: LoginInfo | null }) {
  const code = new URLSearchParams(window.location.search).get("login_error");
  useEffect(() => { document.title = pageTitle("Anmelden"); }, []);
  return (
    <main className="pf-login">
      <div className="pf-login__card">
        <div className="pf-login__mark" role="img" aria-label="SoluCoder" />
        <h1 className="pf-login__title">Mandanten-Plattform</h1>
        <p className="pf-login__hint">Für Plattform-Admins von Solutec. Zugelassen sind einzeln zugewiesene Konten mit der Rolle Platform.Admin.</p>
        {code && <div className="pf-note pf-note--error">{loginErrorText(code)}</div>}
        <a className="pf-btn pf-btn--primary" href="/api/auth/login">{info?.dev ? "Lokal anmelden" : "Mit Microsoft anmelden"}</a>
        <ThemeSwitch />
      </div>
    </main>
  );
}
